import { classifyNumberKey } from "../detect";
import { PRIORITY, type ValueRenderer } from "../types";

function formatNumber(value: number, key: string | undefined): string {
  const cls = classifyNumberKey(key);
  if (cls === "currency") {
    return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 6 }).format(
      value,
    );
  }
  if (cls === "percent") {
    const sign = value > 0 ? "+" : "";
    return `${sign}${value.toFixed(2)}%`;
  }
  if (cls === "count") {
    return new Intl.NumberFormat("en-US").format(value);
  }
  // plain — group thousands, keep up to 8 decimals exactly as given.
  return new Intl.NumberFormat("en-US", { maximumFractionDigits: 8 }).format(value);
}

export const NumberRenderer: ValueRenderer = {
  id: "number",
  match: value => (typeof value === "number" && Number.isFinite(value) ? { priority: PRIORITY.PRIMITIVE } : null),
  Component: ({ value, ctx }) => {
    const num = value as number;
    const cls = classifyNumberKey(ctx.key);
    const colorClass =
      cls === "percent" && num !== 0
        ? num > 0
          ? "text-ds-success-text"
          : "text-ds-error-text"
        : "text-ds-text-primary";
    return <span className={`tabular-nums ${colorClass}`}>{formatNumber(num, ctx.key)}</span>;
  },
};
